import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30a81d30"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "root",
  class: "raraya_name_inputWrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "hide-mobile",
  style: {"text-align":"left"}
}, "ししゅうする文字", -1))
const _hoisted_3 = { class: "inputWrapper" }
const _hoisted_4 = {
  id: "name-input-form",
  class: "name-input-form"
}
const _hoisted_5 = { class: "name-description" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "name-input-container" }
const _hoisted_9 = {
  key: 0,
  id: "raraya_input_field-error",
  class: "error",
  for: "raraya_input_field"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "break" }, null, -1))
const _hoisted_11 = { class: "raraya_name_fixed hide-mobile" }
const _hoisted_12 = { class: "cf" }
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"12px"} }, [
  /*#__PURE__*/_createTextVNode(" 『ネームししゅう』はひらがな、アルファベット（大文字のみ）、記号（上記7種から番号で指定）、ハイフン、ピリオド、中黒、スペースを組み合わせて最大12文字まで入力することができます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※漢字を入力することはできません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※文字は左詰めで入力しますが、実際の刺繍は中央揃えになります。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※文字の書体を選ぶことはできません。 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: require('@/assets/images/img-parts-name01.png')
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: require('@/assets/images/img-parts-name02.png')
            }, null, 8, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            id: "raraya_input_field",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nameTextInput) = $event)),
            placeholder: "12文字まで入ります",
            maxlength: "12",
            onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.nameTextInput]
          ]),
          (_ctx.hasSubmitted && _ctx.nameTextError && _ctx.nameTextError.length > 0)
            ? (_openBlock(), _createElementBlock("label", _hoisted_9, _toDisplayString(_ctx.nameTextError), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          id: "raraya_input_button",
          class: "button hide-mobile",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, "文字数チェックする")
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("ul", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.namePreviews, (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("input", {
                type: "text",
                value: item,
                maxlength: "1",
                class: "raraya_name_input",
                readonly: "true"
              }, null, 8, _hoisted_13)
            ]))
          }), 128))
        ])
      ]),
      _hoisted_14
    ])
  ], 512))
}